import { render, staticRenderFns } from "./WsTitle.vue?vue&type=template&id=2d8038ee&"
import script from "./WsTitle.vue?vue&type=script&lang=js&"
export * from "./WsTitle.vue?vue&type=script&lang=js&"
import style0 from "./WsTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports